import { CabinTypes, Categories } from '../../../interfaces/apiInterfaces/PriceListResponseCruises';
import { ImagePath } from '../../../interfaces/graphQLInterfaces/fetchContentFragmentsResponse';
import { PriceToasterMessage } from '../cabinmacrocategory/CabinMacroCategoryProps';

type CabinCategoryProps = {
  id?: string;
  idx: number;
  priceLabel?: string;
  moreDetailsLabel?: string;
  lessDetailsLabel?: string;
  ribbonLabel?: string;
  zoominIcon?: string;
  zoominIconAriaLabel?: string;
  threesixtyviewIcon?: string;
  threesixtyviewIconAriaLabel?: string;
  connectedroomLabel?: string;
  buttonLabel?: string;
  includedLabel?: string;
  rateDetailsLabel?: string;
  rateDetailsType?: DetailsTypeEnum;
  modalCloseButton?: string;
  cabinData?: CabinCategoryDataProps;
  showHideOption?: string;
  moreDetailsType?: DetailsTypeEnum2;
  accessibleRoomLabel?: string;
  mobileVersionCarousel?: boolean;
  modalIcon?: string;
  modalIconAriaLabel?: string;
  rateDetailsText?: string;
  dataComponentName: string;
  isCabinMacroCategory?: boolean;
  primaryTabLabel?: string;
  secondaryTabLabel?: string;
  renderPrice: (cabinData: CabinCategoryDataProps, index: number) => any;
  modalHeaderTitle?: string;
  prevImageIconTooltip?: string;
  nextImageIconTooltip?: string;
  priceToasterMessage?: PriceToasterMessage;
};

export enum CabinCodeEnum {
  INS = 'INS',
  OUT = 'OUT',
  BAL = 'BAL',
  SUI = 'SUI',
  YTC = 'YTC',
}

export enum CabinTypeEnum {
  INS = 'Interior',
  OUT = 'Ocean View',
  BAL = 'Balcony',
  SUI = 'Suite',
  YTC = 'MSC Yacht Club',
}

type CabinCategoryWrapperProps = {
  id?: string;
  priceLabel?: string;
  moreDetailsLabel?: string;
  lessDetailsLabel?: string;
  ribbonLabel?: string;
  zoominIcon?: string;
  zoominIconAriaLabel?: string;
  threesixtyviewIcon?: string;
  threesixtyviewIconAriaLabel?: string;
  connectedroomLabel?: string;
  buttonLabel?: string;
  includedLabel?: string;
  rateDetailsLabel?: string;
  rateDetailsType: DetailsTypeEnum;
  rateDetailsText?: string;
  modalCloseButton?: string;
  showHideOption: string;
  moreDetailsType: DetailsTypeEnum2;
  accessibleRoomLabel: string;
  mobileVersionCarousel: boolean;
  modalIcon: string;
  modalIconAriaLabel: string;
  dataComponentName?: string;
  storybookProps?: {
    finalCategories: CabinCategoryDataProps[];
  };
  cabinData?: CabinMacroCategoryDataProps;
  showIncludedLabel?: string;
  primaryTabLabel?: string;
  secondaryTabLabel?: string;
  disableIncludedLabel?: boolean;
  modalHeaderTitle?: string;
  prevImageIconTooltip?: string;
  nextImageIconTooltip?: string;
  priceToasterMessage?: PriceToasterMessage;
};

type CabinCategoryDataProps = {
  title?: string;
  description?: { html: string };
  modalDescription?: { html: string };
  technicalDescription?: { html: string };
  disclaimer?: { html: string };
  deck?: string;
  pax?: string;
  surface?: string;
  deckLabel?: string;
  paxLabel?: string;
  surfaceLabel?: string;
  balconyLabel?: string;
  balconySurface?: string;
  price?: string;
  priceOld?: string;
  hasConnectedroom?: boolean;
  hasAccessibleroom?: boolean;
  view360Source?: string;
  cabinImages?: ImagePath[];
  cabinBackgroundColor?: string;
  categoryChipColour?: string;
  isAvailable?: boolean;
  categoryCode: string;
  macroCategory?: string;
  cabinObj: Categories;
  benefits?: {
    experienceTitle?: string;
    experienceDescription?: { html: string };
    experienceCode?: string;
  };
};

type CabinCategoryContentFragmentMappedProps = {
  id: string;
  title?: string;
  description?: { html: string };
  cabinImages?: ImagePath[];
  cabinBackgroundColor?: string;
  categoryChipColour?: string;
};

type CabinCategoryAPIDataPropsWObj = {
  price?: string;
  priceOld?: string;
  categoryCode: string;
  macroCategory?: string;
  hasConnectedroom?: boolean;
  hasAccessibleroom?: boolean;
  isAvailable?: boolean;
  cabinObj: Categories;
};

type CabinMacroCategoryAPIDataPropsWObj = {
  price?: string;
  priceOld?: string;
  categoryCode: string;
  macroCategory?: string;
  hasConnectedroom?: boolean;
  hasAccessibleroom?: boolean;
  isAvailable?: boolean;
  cabinObj: CabinTypes;
};

type CabinMacroCategoryDataProps = {
  cabinObj: CabinTypes;
  price?: string;
  priceOld?: string;
  categoryCode: string;
  macroCategory?: string;
  surface?: string;
  pax?: string;
  deck?: string;
  deckLabel?: string;
  paxLabel?: string;
  surfaceLabel?: string;
  hasConnectedroom?: boolean;
  hasAccessibleroom?: boolean;
  isAvailable?: boolean;
  title?: string;
  view360Source?: string;
  description?: { html: string };
  cabinImages?: ImagePath[];
  cabinBackgroundColor?: string;
  benefits?: {
    experienceTitle?: string;
    experienceDescription?: { html: string };
    experienceCode?: string;
  }[];
};

export enum DetailsTypeEnum {
  SIMPLETEXT = 'simpleText',
  MODAL = 'modal',
  TOOLTIP = 'tooltip',
}

export enum DetailsTypeEnum2 {
  ACCORDION = 'accordion',
  MODAL = 'modal',
  TOOLTIP = 'tooltip',
}

export enum ComponentTypeEnum {
  CABINMACROCATEGORY = 'cabinmacrocategory',
  CABINCATEGORY = 'cabincategory',
}

export type {
  CabinCategoryProps,
  CabinCategoryWrapperProps,
  CabinCategoryDataProps,
  CabinCategoryContentFragmentMappedProps,
  CabinMacroCategoryDataProps,
  CabinCategoryAPIDataPropsWObj,
  CabinMacroCategoryAPIDataPropsWObj,
};
